// extracted by mini-css-extract-plugin
export default {"modalOverlay":"oL-z","modalContent":"pL-z","header":"qL-z","close":"rL-z"};